import { state, style, AUTO_STYLE, transition, animate, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';
import { SubscriptionHolderPaymentMean } from '@app/core/services/subscription/models/subscription/subscription-holder-payment-mean.model';
import { SubscriptionPayerPaymentMean } from '@app/core/services/subscription/models/subscription/subscription-payer-payment-mean.model';

const DEFAULT_DURATION = 300;

@Component({
    selector: 'ap-subscription-payment-mean',
    templateUrl: './subscription-payment-mean.component.html',
    styleUrls: ['./subscription-payment-mean.component.css'],
    animations: [
        trigger('collapse', [
            state('true', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
            state('false', style({ height: '0', visibility: 'hidden' })),
            transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
            transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
        ])
    ],
    standalone: false
})
export class SubscriptionPaymentMeanComponent {

  collapse = false;

  @Input() paymentMean: SubscriptionHolderPaymentMean | SubscriptionPayerPaymentMean

}

